var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94183 12.5C4.94183 12.1918 5.19172 11.9419 5.49997 11.9419H19.5C19.8082 11.9419 20.0581 12.1918 20.0581 12.5C20.0581 12.8083 19.8082 13.0582 19.5 13.0582H5.49997C5.19172 13.0582 4.94183 12.8083 4.94183 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1053 5.10537C12.3233 4.8874 12.6767 4.8874 12.8946 5.10537L19.8946 12.1054C20.1126 12.3233 20.1126 12.6767 19.8946 12.8947L12.8946 19.8947C12.6767 20.1127 12.3233 20.1127 12.1053 19.8947C11.8873 19.6767 11.8873 19.3233 12.1053 19.1054L18.7106 12.5L12.1053 5.8947C11.8873 5.67673 11.8873 5.32334 12.1053 5.10537Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.789390c8645606189393786a3bb55e4c.svg";
export { ForwardRef as ReactComponent };